/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-south-1",
    "aws_cloud_logic_custom": [
        {
            "name": "geo",
            "endpoint": "https://p2fqpvyt48.execute-api.eu-south-1.amazonaws.com/production",
            "region": "eu-south-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://fd636xsrb5fmvdh3sbaukd4bty.appsync-api.eu-south-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-south-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "eu-south-1:4244a377-4d7d-46cb-95af-9e40df3e398e",
    "aws_cognito_region": "eu-south-1",
    "aws_user_pools_id": "eu-south-1_8s0Z5obSa",
    "aws_user_pools_web_client_id": "50f12515md75hpfd2lu0hfv7cs",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
